import { Center } from 'styled-system/jsx';
import Button from '@/common/components/base/button/Button.tsx';
import { useNavigate } from 'react-router-dom';
import { FILE_DETAIL_LINKS } from '@/modules/FileDetail/FileDetailLinks.ts';
import ArrowLeft from '@/common/assets/icons/leftPoint.svg?react';
import { token } from 'styled-system/tokens';
import { SharedActionProps } from '@/modules/FileList/components/fileDetailCardActions/FileListlAction.type.ts';

export default ({ fileId }: SharedActionProps) => {
  const navigate = useNavigate();
  const goToFile = () => {
    navigate(FILE_DETAIL_LINKS.detail(fileId));
  };
  return (
    <Center
      onClick={goToFile}
      key={fileId}
      borderTop="1px solid {colors.gray-2}"
    >
      <Button gap="5px" fullWidth variant="text" color="primary">
        <ArrowLeft fill={token('colors.purple-2')} />
        ورود به صفحه پرونده
      </Button>
    </Center>
  );
};
